import { useQuery } from "@tanstack/react-query";
import { getService } from "../services";

export function useService(id: number) {
  const isValidId = Number.isFinite(id) && id > 0;

  return useQuery({
    queryKey: ["service", id],
    queryFn: () => getService(id),
    enabled: isValidId,
  });
}
